/**
 * Primary controller for viewing a single task at /task/task/:id
 * @author Ryan Gladstone, Brendan Magee
 */

function TaskController(
  $scope,
  $stateParams,
  $log,
  $translate,
  $window,
  confirmationDialog,
  Task,
  tasksService,
  taskModalService,
  toastWrapperService,
  LoggedInUser,
  layoutService,
  analyticsService,
  featureFlag
) {
  $scope.currentUser = LoggedInUser;

  $scope.alerts = [];
  $scope.layout = layoutService;
  $scope.loading = true;

  $scope.tasksv2enabled = false;
  featureFlag.isEnabled('tasksv2').then((enabled) => {
    $scope.tasksv2enabled = enabled;
  });

  $scope.$watch('tasksv2enabled', (enabled) => {
    if (enabled) {
      $window.location.href = `/websked/1/tasks/task/${$stateParams.id}`;
    }
  });

  function loadTaskData() {
    Task.get($stateParams.id).then(
      (data) => {
        $scope.task = data;

        if ($scope.task.storyID) {
          tasksService
            .getTasksByStoryId(
              $scope.task.storyID,
              $scope.task.story,
              $scope.task.id
            )
            .then(
              (tasksData) => {
                $scope.loading = false;
                $scope.otherTasks = tasksData;
              },
              (tasksResponse) => {
                $log.error('getTasksByStoryId error: ', tasksResponse);
                $scope.loading = false;
                $scope.fatalError = tasksResponse.data.error;
              }
            );
        } else {
          $scope.loading = false;
        }
      },
      (response) => {
        $log.error('TaskController Task.get() error', response);
        $scope.loading = false;
        if (response.data && response.data.error) {
          $scope.fatalError = response.data.error;
        } else if (response.data) {
          $scope.fatalError = response.data;
        }
      }
    );
  }

  if (angular.isDefined($stateParams.id) && $stateParams.id !== '') {
    loadTaskData();
  } else {
    $log.warn('Missing $stateParams.id');
    $scope.loading = false;
    $scope.fatalError = $translate.instant('ERROR_LOADING_DATA');
  }

  function deleteConfirmedAction() {
    $scope.task.delete().then(
      (response) => {
        $scope.taskDeleted = true;
        $scope.task.id = null;
        $log.log('task deleted successfully: ', response);

        analyticsService.trackEvent(
          'Task management (single task)',
          'Deleted task'
        );
      },
      (response) => {
        // handle rejected promise here
        $scope.alerts.push({ type: 'danger', msg: response });
      }
    );
  }

  $scope.delete = () => {
    confirmationDialog.confirm('DELETE_TASK_Q', deleteConfirmedAction);
  };

  // //////////////////////
  // Callback Functions //
  // //////////////////////

  function updateSuccess(task) {
    const updatedTask = task;
    if (updatedTask) {
      updatedTask.story = angular.copy($scope.task.story);
      $scope.task = updatedTask;

      toastWrapperService.createToast(
        $translate.instant('TASK_UPDATED'),
        'success'
      );
      analyticsService.trackEvent(
        'Task management (single task)',
        'Updated task'
      );
    }
  }

  $scope.updateTask = () => {
    taskModalService.saveTask(updateSuccess, $scope.task);
  };

  $scope.getAdditionalFieldLabel = (customFieldKey) => {
    if (!$scope.task.customFieldLabels) {
      return '';
    }

    const customField = $scope.task.customFieldLabels.find(
      (af) => af.name === customFieldKey
    );
    return customField ? customField.label : '';
  };
}

const TaskCtrlArray = [
  '$scope',
  '$stateParams',
  '$log',
  '$translate',
  '$window',
  'confirmationDialog',
  'Task',
  'tasksService',
  'taskModalService',
  'toastWrapperService',
  'LoggedInUser',
  'layoutService',
  'analyticsService',
  'featureFlag',
  TaskController
];

export default function (ngModule) {
  ngModule.controller('TaskController', TaskCtrlArray);
}
